import axios from 'utils/axios';
import { all, fork, put, takeLatest, select } from 'redux-saga/effects';
import { LOGIN, FORGOT_PASSWORD, RESET_PASSWORD, OTP, RESET_PASSWORD2 } from 'redux/auth/constants';
import { loginSuccess, setLoader } from './actions';
import { sagaErrorHandler } from 'shared/helperMethods/sagaErrorHandler';
import { SetNotification } from 'shared/helperMethods/setNotification';
import { makeSelectAuthToken } from 'store/Selector';

function* loginUser({ payload }) {
    try {
        let data = {
            email: payload.email,
            password: payload.password
        };
        const response = yield axios.post(`/admin/auth/login`, data);
        yield put(setLoader(false));
        // yield SetNotification('success', response.data.message);
        yield put(loginSuccess(response.data.data));
    } catch (error) {
        yield put(setLoader(false));
        yield sagaErrorHandler(error.response.data.data);
    }
}

function* forgetPasswordRequest({ payload }) {
    try {
        let data = {
            email: payload.email
        };
        const response = yield axios.post(`/admin/forgetPassword`, data);
        yield SetNotification('success', response.data.message);
        payload.navigate('/');
    } catch (error) {
        yield sagaErrorHandler(error.response.data.data);
    }
}

function* resetPasswordRequest({ payload }) {
    try {
        let data = {
            newPassword: payload.password,
            token: payload.token
            // email: 'admin@gmail.com',
            // newPassword: 'Password'
        };
        const headers = { headers: { Authorization: `Bearer ${yield select(makeSelectAuthToken())}` } };
        const response = yield axios.put(`/admin/resetPassword`, data, headers);
        yield SetNotification('success', response.data.message);
        payload.navigate('/');
    } catch (error) {
        yield sagaErrorHandler(error.response.data.data);
    }
}

export function* watchLogin() {
    yield takeLatest(LOGIN, loginUser);
}

export function* watchForgetPassword() {
    yield takeLatest(FORGOT_PASSWORD, forgetPasswordRequest);
}
export function* watchResetPassword() {
    yield takeLatest(RESET_PASSWORD, resetPasswordRequest);
}

function* otpUser({ payload }) {
    try {
        let data = {
            otp: payload.otp
        };
        const response = yield axios.post(`/admin/verify-password-otp`, data);
        yield put(setLoader(false));
        yield SetNotification('success', response.data.message);
        yield put(loginSuccess(response.data.data));
    } catch (error) {
        yield put(setLoader(false));
        yield sagaErrorHandler(error.response.data.data);
    }
}

export function* watchOTP() {
    yield takeLatest(OTP, otpUser);
}

function* resetPassword2Request({ payload }) {
    try {
        let data = {
            newPassword: payload.password,
            // otp: payload.otp,
            token: payload.token
        };
        const headers = { headers: { Authorization: `Bearer ${yield select(makeSelectAuthToken())}` } };
        const response = yield axios.put(`/admin/reset-password`, data, headers);
        yield SetNotification('success', response.data.message);
        payload.navigate('/');
    } catch (error) {
        yield sagaErrorHandler(error.response.data.data);
    }
}
export function* watchResetPassword2() {
    yield takeLatest(RESET_PASSWORD2, resetPassword2Request);
}
export default function* authSaga() {
    yield all([fork(watchLogin), fork(watchForgetPassword), fork(watchResetPassword), watchOTP, fork(watchResetPassword2)]);
}
